const getLinkFromSlot = (slot) => {
  if (!slot) return null;
  if (slot instanceof HTMLAnchorElement) {
    return slot;
  }
  const links = slot.querySelectorAll("a");
  if (links.length === 0) return null;
  if (links.length > 1) {
    console.warn(
      "Multiple links found in slot. Using the first link and removing parent elements of additional links."
    );
    const firstLink = links[0];
    Array.from(slot.children).forEach((child) => {
      if (child instanceof HTMLAnchorElement && child !== firstLink) {
        child.remove();
        return;
      }
      const childLinks = child.querySelectorAll("a");
      if (childLinks.length > 0 && !child.contains(firstLink)) {
        child.remove();
      }
    });
  }
  return slot;
};
export {
  getLinkFromSlot
};
//# sourceMappingURL=getLinkFromSlot.js.map
